import React from 'react';

import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Tooltip } from 'common/components';
import { ReactHookFormSelect } from 'common/components/form/bootstrap';
import {
    IconDoublePitched,
    IconSinglePitched,
} from 'common/components/icons/index.jsx';
import { getSlopeOptions } from 'common/utils/helpers/systemsValues';

const SloofTypeFieldWithTooltip = ({
    control,
    disabled,
    onChange,
    systemUid,
}) => {
    const { t } = useTranslation();
    const options = getSlopeOptions(systemUid);
    return (
        <Box sx={{ display: 'flex', gap: 1 }}>
            <ReactHookFormSelect
                control={control}
                label={i18next.t('Slope type')}
                name="sloof_type"
                onChange={onChange}
                options={options}
                disabled={disabled}
            />

            <Box>
                <Tooltip sx={{ p: 2 }} color={disabled ? '#ec4d4dd1' : null}>
                    {!disabled ? (
                        <>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                gap={2}
                                mb={2}
                            >
                                <Box textAlign="center">
                                    <IconSinglePitched />
                                    <Typography
                                        variant="body1"
                                        fontWeight="bold"
                                    >
                                        {t('Single-pitched')}
                                    </Typography>
                                </Box>
                                <Box textAlign="center">
                                    <IconDoublePitched />
                                    <Typography
                                        variant="body1"
                                        fontWeight="bold"
                                    >
                                        {t('Double-pitched')}
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography variant="body2">
                                {t(
                                    "Select 'single-pitched' for roofs with one slope and 'double-pitched' for roofs with two slopes forming a peak or triangle.",
                                )}
                            </Typography>
                        </>
                    ) : (
                        <Typography variant="body2">
                            {t(
                                "The slope type is determined by the roof's geometry. To change it, please choose rectangular roof tool.",
                            )}
                        </Typography>
                    )}
                </Tooltip>
            </Box>
        </Box>
    );
};

SloofTypeFieldWithTooltip.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    systemUid: PropTypes.string,
};

export default SloofTypeFieldWithTooltip;
